/** Retention presets per data class (M29 SEC-007). Mirrors `backend/app/core/constants/retention_presets.py` (checked by `backend/tests/core/test_retention_presets_mirror.py`). */

/** `RetentionClass` values, in the order the backend declares them. */
export const RETENTION_CLASS_VALUES = ["chats", "tickets", "customer_context_history", "launch_sessions", "audit_security"] as const;

/** `RetentionPresetKey` values. */
export const RETENTION_PRESET_VALUES = ["standard", "aml_5_years"] as const;

export const RETENTION_DAYS_PER_YEAR = 365 as const;

/** Days per class of each preset (the ticket figure is whole years). */
export const RETENTION_PRESET_DAYS = {
  standard: { chats: 365, tickets: 1825, customer_context_history: 365, launch_sessions: 7, audit_security: 730 },
  aml_5_years: { chats: 1825, tickets: 1825, customer_context_history: 1825, launch_sessions: 7, audit_security: 1825 },
} as const;

/** Launch sessions are always deleted this many days after they ended. */
export const LAUNCH_SESSIONS_FIXED_DAYS = 7 as const;

/** Longest `action_prefix` of the audit view. */
export const AUDIT_ACTION_PREFIX_MAX = 32 as const;

/** Audit trails the privacy page filters by. */
export const AUDIT_PREFIXES = ["launch.", "customer.", "api_key."] as const;
